module.exports = __webpack_public_path__ + "img/banner-1.1d45ec7b.png";